<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-line"></span> 周边销售
            </span>
            <router-link v-if="$utils.have('/sales/goods/goods_list') && intervalData" class="fr color-theme" :to="`/report/sales/surrounding?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">
                查看详情<span class="el-icon-right"></span>
            </router-link>
        </div>
        <div class="content">
            <el-alert type="warning" :closable="false">
                <div slot="title">
                    <span class="num">待处理待发货订单: <b>{{data && data.waitSendTotalNum}}</b> <router-link to="/goodsManage/order/list?orderStatus=2">立即查看</router-link></span>
                    <span class="num">待处理待退款商品: <b>{{data && data.refundingGoodsTotalNum}}</b> <router-link to="/goodsManage/order/list?refundStatus=1">立即查看</router-link></span>
                </div>
            </el-alert>
            <el-tabs v-model="activeName"  @tab-click="clickTab" class="MT10">
                <el-tab-pane label="销售额" name="1"></el-tab-pane>
                <el-tab-pane label="订单数" name="2"></el-tab-pane>
                <el-tab-pane label="商品数" name="3"></el-tab-pane>
            </el-tabs>
            <div class="data-box">
                <div class="total">{{activeName == 1 ? '销售额:' : activeName == 2 ? '订单数:' : '商品数:' }} <b>{{data && data.totalSum}} </b> </div>
                <div id="goodsSaleschart" ref="goodsSaleschart"></div>
            </div>
        </div>
    </el-card>
</template>

<script>

import { Chart } from '@antv/g2';
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            activeName: "1",
            chart: null,
        }
    },
    
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/goodsdata",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                    dataType: this.activeName
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        // this.categoryDataList = result.categoryDataList;

                        this.$nextTick(() => {
                            this.drawChart();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.getData();
        },
        
        drawChart(){
            if( this.chart ) this.chart.destroy();
            let _data = [];
            const _dataArry = [...this.data.totalNumChart.lineSeriesData];

            _dataArry.map( item => {
                _data.push({
                    name: item.name,
                    value: parseFloat(item.value)
                })
            })
            
            this.chart = new Chart({
                container: 'goodsSaleschart',
                autoFit: true,
                height: 300,
            });
            this.chart.data(_data);

            if( _dataArry.length > 7 ){
                this.chart.option('slider', {
                    start: (_dataArry.length - 7) / _dataArry.length,
                    end: 1,
                });
            }

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
            });
            
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });

            this.chart.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    .el-alert{
        .num{
            margin-right: 30px;
            color: $--color-font-normal;
            b{
                font-weight: 700;
                font-size: 16px;
            }
        }
        a{
            color: $--color-theme;
        }
    }
    .total{
        margin:10px 0 25px 0;
        b{
            font-size: 18px;
            font-weight: 700;
        }
    }
}
</style>